/*
 * COD Coverage Validator (coverage only — no talla/variant enforcer)
 *
 * Reads Shopify-rendered whitelists from window.CODCoverageData:
 *   codList / advA / advB / advC
 *
 * Toggles COD + advance-payment buttons by ZIP and shows coverage messages.
 */
(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Coverage whitelists
  // ---------------------------------------------------------------------------

  function parseList(raw) {
    return new Set(
      (typeof raw === 'string' ? raw : '')
        .split(/[\r\n,]+/)
        .map(function (s) { return s.trim(); })
        .filter(function (s) { return s.length > 0; })
    );
  }

  var data = window.CODCoverageData || {};
  var codWhitelist      = parseList(data.codList);
  var advanceWhitelistA = parseList(data.advA);
  var advanceWhitelistB = parseList(data.advB);
  var advanceWhitelistC = parseList(data.advC);

  function inAdvance(zip) {
    return advanceWhitelistA.has(zip) || advanceWhitelistB.has(zip) || advanceWhitelistC.has(zip);
  }
  function advanceHasAny() {
    return advanceWhitelistA.size > 0 || advanceWhitelistB.size > 0 || advanceWhitelistC.size > 0;
  }

  function getCodButton() {
    return document.querySelector('._rsi-build-block-submit-button');
  }
  function getAdvanceButtons() {
    return document.querySelectorAll('a._rsi-buy-now-custom-additionals-button');
  }
  function getZipInput() {
    var el = document.querySelector('#_rsi-cod-form-modal-form input[data-type="zip_code"]');
    if (el) return el;
    el = document.querySelector('#_rsi-cod-form-modal-form [name*="zip"]');
    if (el) return el;
    return document.querySelector('#_rsi-cod-form-modal-form select[data-type="zip_country_field"]');
  }

  function showBtn(b) { if (b) b.style.setProperty('display', 'block', 'important'); }
  function hideBtn(b) { if (b) b.style.setProperty('display', 'none', 'important'); }
  function showEach(list) { for (var i = 0; i < list.length; i++) showBtn(list[i]); }
  function hideEach(list) { for (var i = 0; i < list.length; i++) hideBtn(list[i]); }

  // ---------------------------------------------------------------------------
  // Friendly "sin cobertura" message
  // ---------------------------------------------------------------------------

  var MSG_ID = '_cod-no-coverage-message';

  var MSG_FULL =
    '<strong>¡Lo sentimos!</strong><br>' +
    'Por el momento no contamos con cobertura de envío para tu código postal. ' +
    'Estamos trabajando para llegar pronto a tu zona. ' +
    'Si necesitas ayuda, por favor contáctanos.';

  var MSG_COD_ONLY =
    '<strong>Pago contra entrega no disponible</strong><br>' +
    'Tu código postal no cuenta con cobertura para pago contra entrega. ' +
    'Puedes finalizar tu compra con <strong>pago anticipado</strong>.';

  function ensureMessage() {
    var zipEl = getZipInput();
    if (!zipEl) return null;

    var msg = document.getElementById(MSG_ID);
    if (!msg) {
      msg = document.createElement('div');
      msg.id = MSG_ID;
      msg.setAttribute('role', 'status');
      msg.setAttribute('aria-live', 'polite');
      msg.style.cssText = [
        'display:none',
        'margin:14px 0',
        'padding:14px 16px',
        'border-radius:10px',
        'background:#fff4e5',
        'border:1px solid #ffb74d',
        'color:#7a4e00',
        'font-size:14px',
        'line-height:1.45',
        'text-align:center',
        'font-family:inherit'
      ].join(';');
    }

    // Keep the message anchored right below the ZIP input's field container.
    var anchor = zipEl.closest('._rsi-modal-fields-item') || zipEl.parentElement;
    if (anchor && anchor.parentNode && msg.parentNode !== anchor.parentNode) {
      anchor.parentNode.insertBefore(msg, anchor.nextSibling);
    }
    return msg;
  }

  function showMsg(html) {
    var m = ensureMessage();
    if (!m) return;
    var next = html || MSG_FULL;
    if (m.innerHTML !== next) m.innerHTML = next;
    m.style.display = 'block';
  }
  function hideMsg() { var m = ensureMessage(); if (m) m.style.display = 'none'; }

  function evaluateZip() {
    var codBtn  = getCodButton();
    var advBtns = getAdvanceButtons();
    if (!codBtn && (!advBtns || advBtns.length === 0)) return;

    var zipEl  = getZipInput();
    var zip    = zipEl ? (zipEl.value || '').trim() : '';
    var hasZip = !!zipEl && zip.length >= 5;

    var codConfigured = codWhitelist.size > 0;
    var advConfigured = advanceHasAny();
    var codInList     = codWhitelist.has(zip);
    var advInList     = inAdvance(zip);

    // --- COD button visibility ---
    var codVisible = false;
    if (codBtn) {
      if (!hasZip || !codConfigured || codInList) {
        showBtn(codBtn);
        codVisible = true;
      } else {
        hideBtn(codBtn);
      }
    }

    // --- Advance-payment buttons visibility ---
    var advVisible = false;
    if (advBtns && advBtns.length) {
      if (!hasZip || !advConfigured || advInList) {
        showEach(advBtns);
        advVisible = true;
      } else {
        hideEach(advBtns);
      }
    }

    // --- Coverage notices ---
    // COD se ofrece en esta pagina pero el CP (completo) no esta en la lista COD.
    var codOut = hasZip && codConfigured && !!codBtn && !codInList;
    if (codOut && advVisible) {
      // COD sin cobertura, pero el pago anticipado si esta disponible.
      showMsg(MSG_COD_ONLY);
    } else if (hasZip && !codVisible && !advVisible && (codConfigured || advConfigured)) {
      // Nada disponible para este CP.
      showMsg(MSG_FULL);
    } else {
      hideMsg();
    }
  }

  var zipAttached = false;
  function attachZip() {
    if (zipAttached) return;
    var zipEl = getZipInput();
    if (!zipEl) return;
    zipAttached = true;
    zipEl.addEventListener('input', evaluateZip);
    zipEl.addEventListener('change', evaluateZip);
    evaluateZip();
  }

  // ---------------------------------------------------------------------------
  // Bootstrap (coverage only — no variant/talla enforcer)
  // ---------------------------------------------------------------------------

  function tick() {
    attachZip();
    evaluateZip();
  }

  function start() {
    tick();
    new MutationObserver(function () {
      tick();
    }).observe(document.documentElement, { childList: true, subtree: true });

    var c = 0;
    var iv = setInterval(function () {
      tick();
      if (++c > 120) clearInterval(iv);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();